module.exports = __webpack_public_path__ + "static/media/4-iveco.5ef8158c.jpg";